<template>
	<div class="modal" @click.stop="close">
		<Card class="modal__card" @click.native.stop>
			<div class="modal__close">
				<Action title="Close" @click="close">
					<IconClose />
				</Action>
			</div>
			<div class="modal__content">
				<slot />
			</div>
		</Card>
	</div>
</template>

<script>
import IconClose from 'mdi-vue/Close'
import Card from '@/components/shared/Card'
import Action from '@/components/shared/Action'

export default {
	name: 'AdminModal',
	methods: {
		close() {
			this.$emit('close')
		}
	},
	components: {
		Card,
		Action,
		IconClose
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/layout';
@import '~scss/components';

.modal {
	@extend %modal;
	overflow-y: scroll;

	&__card {
		position: relative;
		margin: auto;
		width: calc(100vw - 3rem);
		max-width: 40rem;
	}

	&__close {
		position: absolute;
		top: 0.5rem;
		right: 0.5rem;
	}

	&__content {
		@include truncate-margin;
	}
}
</style>
